<template>
<div id="dashboard">
  <div v-if="!states.viewAllow && !states.showFail" class="loader overlay">
    <img class="overlay-container" src="@/assets/img/loader.gif" />
  </div>
  <div  v-if="states.showFail">
    <p></p>
      <div v-if="states.onServerError" class="text-center">
      <label>Došlo k neočakávanej chybe. Skúste neskôr.</label>
      </div>
      <div v-else>
      <p class="text-center" v-if="tplData.general"><label v-html="tpl('general.errorLoading')"></label></p>
      </div>
  </div>
  <div v-if="states.viewAllow">

    <div class="row" v-if="states.isPecka !== 'Y'">
      <div v-if="states.mainView">
      <detail :states="states" :productdetail="productdetail" :tplData="tplData" :filterBouquet="filterBouquet"></detail>
      <div class="large-12 medium-12 small-12 columns"> 
        <a class="actions action" v-on:click="states.mainView = !states.mainView; states.creloadView = !states.creloadView">Dobiť kredit</a>      

          <div v-html="tpl('credit.description')"></div>

        <hr class="top" v-show="!states.showMixi">
      </div>
      <div class="large-12 medium-12 small-12 columns" style="margin-top:0.7rem" v-if="states.showMixi"> 
        <img class="leftIco inline" src="graphics/ico_cal.png" /> <span class="midleLabel inline fet">{{tplData.package.name.Mixi}}</span>
<!-- MIXI SPOTREBA -->
        <div v-for="(pkgView, pmIndex) in mixiDataFromBq" :key="pmIndex">
        <div v-bind:class="{ 'mixi_title': pmIndex === 0 }"><strong>{{pkgView.readable}}</strong></div>
        <div>          
          <div class="progress-bar" v-if="!pkgView.isInfinite">
              <div class="vonkajsi">
                  <div class="vnutorny shadow" v-bind:style="{ width: pkgView.percentageNeg + '%' }">
                    <span class="inner-text text-left">{{pkgView.pgLeftText}}</span> 
                  </div>
                  <div class="vnutorny-right" v-bind:style="{ width: pkgView.percentagePos + '%' }"> <span class="inner-text text-right-in">{{ pkgView.pgVal }}</span>
              </div>
              </div> 
              <span class="inner-text text-left-out">{{ pkgView.pgLeftText }}</span> <span class="inner-text text-right">{{ pkgView.pgVal }}</span> 
          </div>
          <div class="progress-bar" style="position:relative;"  v-if="pkgView.isInfinite"><span class="inner-text text-right-in">{{ pkgView.pgVal }}</span>
              <div class="vnutorny" style="width: 51%">
                  <div class="opacity-grad"><span class="inner-text text-left-inf">{{ pkgView.pgLeftText }}</span></div>
              </div>
          </div>
        </div>   
        <div class="mixi_validity">
          <span class="inline" v-html="pkgView.prolongable ? 'Dátum obnovenia' : 'Platí do'" /><span data-v-73e1cf68="" class="right">{{ pkgView.endDate }}</span>
        </div>
        </div>
<!--
        <hr class="top" v-show="(baseView.mixiProlongList || []).length > 0">
        <div v-for="(mProl, pix) in baseView.mixiProlongList" :key="'mprol' + pix" class="mb-3">
          <div  v-if="mProl.action">
            <div class="mixi-prol-wrap">
            <div><strong>Automatické predĺženie Mixi{{ mProl.periodObj.appendTitle }}</strong></div>
            <div class="mprol-right">zapnuté</div>
          </div>
          <div class="mixi-prol-wrap">
            <div>Dátum obnovy balíčka</div>
            <div class="mprol-right" v-html="mProl.nextChargeDate" />
          </div>
          <a class="actions action" 
            v-on:click="states.creditActionView = true, states.creditAction.type = 'stop', states.creditAction.command = mProl.commandName, states.creditAction.cGroup = mProl.commandType"
            >Vypnúť automatické predĺženie</a>
          </div>
        </div>
-->
        <hr class="top">
      </div>

      <mirri :productdetail="productdetail" :tplData="tplData" v-if="isMirri" />

      </div>
      <creload v-if="states.creloadView" :states="states" :productdetail="productdetail" :tplData="tplData" :filterBouquet="filterBouquet"></creload>
      <datainfo  v-if="states.mainView && !states.dataHide" :states="states" :productdetail="productdetail" :tplData="tplData" :filterBouquet="filterBouquet" :typeExists="typeExists" @dataCount="dataCount"></datainfo>
      <div class="large-12 medium-12 small-12 columns" v-if="states.mainView && !states.dataHide"> 
      <hr class="top">
      </div>
      <datadetail v-if="states.datadetailView" :states="states" :productdetail="productdetail" :tplData="tplData" :filterBouquet="filterBouquet" :typeExists="typeExists"></datadetail>
      <creditaction v-if="states.creditActionView" :states="states" :productdetail="productdetail" :tplData="tplData"></creditaction>

           <div v-if="baseView.voicePkg && states.mainView">
           <div class="large-12 medium-12 small-12 columns">
                <img class="leftIco inline" src="graphics/ico_min.png"/>
                <span class="midleLabel inline fet" v-html="baseView.voicePkgTitle"></span><p></p>
            </div>
            <div class="large-12 medium-12 small-12 columns" style="margin: -0.5rem 0 0">
                <span class="inline">Platí do</span>
                <span class="right" v-html="baseView.voicePkgVal"></span>
            </div>            
            <div class="large-12 medium-12 small-12 columns" v-if="baseView.voicePkgShow">
                <span class="inline">Automatické predĺženie</span>
                <span class="right" v-html="baseView.voicePkgProlTxt"></span>
                <a class="actions action" v-if="baseView.voicePkgProl" v-on:click="states.creditActionView = true, states.creditAction.type = 'stop', states.creditAction.command = 'ActivateFVO'">Vypnúť automatické predĺženie</a>                        
          </div></div>

           <div v-if="baseView.messPkg && states.mainView">
           <div class="large-12 medium-12 small-12 columns">
            <hr class="top">
                <img class="leftIco inline" src="graphics/ico_messages.png"/>                
                <span class="midleLabel inline fet">Neobmedzené SMS</span><p></p>
            </div>
            <div class="large-12 medium-12 small-12 columns" style="margin: -0.5rem 0 0">
                <span class="inline">Platí do</span>
                <span class="right" v-html="baseView.messPkgVal"></span>
            </div>
            <div class="large-12 medium-12 small-12 columns">
                <span class="inline">Automatické predĺženie</span>
                <span class="right" v-html="baseView.messPkgProlTxt"></span>
                <a class="actions action" v-if="baseView.messPkgProl" v-on:click="states.creditActionView = true, states.creditAction.type = 'stop', states.creditAction.command = 'ActivateFSS'">Vypnúť automatické predĺženie</a>                        
            </div>
          </div>  
         <div v-if="baseView.fnfPkg && states.mainView">
           <div class="large-12 medium-12 small-12 columns">
            <hr class="top">
           </div>
          <div v-for="fnfNr in freeCallNrsArr" :key="fnfNr.name">
          <div class="large-12 medium-12 small-12 columns">
                <img class="leftIco inline" src="graphics/ico_phone.png"/>                
                <span class="midleLabel inline fet">Volania na {{ formatMsisdn(fnfNr.benefitMsisdn) }}</span>
            </div>
            <div class="large-12 medium-12 small-12 columns xspace">
                <span class="inline">Platí do</span>
                <span class="right" v-html="moment(fnfNr.endDate || fnfNr.nextChargeDate).format('D.M.YYYY H:mm')"></span>
            </div>
            <div class="large-12 medium-12 small-12 columns">
                <span class="inline">Automatické predĺženie</span>
                <span class="right" v-html="fnfNr.fnfPkgProlTxt"></span>
                <a class="actions action" v-if="fnfNr.fnfPkgProl" v-on:click="states.creditActionView = true, states.creditAction.type = 'stop', states.creditAction.command = 'FnF', states.creditAction.fnfExt = (fnfNr.benefitMsisdn || '')">Vypnúť automatické predĺženie</a>                        
                <p></p>
            </div>
          </div>
        </div>
    </div>
    <div v-else class="row">
      <div class="large-12 medium-12 small-12 columns text-center"> 
        <div class="swipe-alert">
          Služba SWIPE nie je na tejto stránke podporovaná. Pre pohodlné spravovanie služby SWIPE použite mobilnú aplikáciu SWIPE.
        </div>
      </div>
    </div>
  </div>
  <p>&nbsp;</p>
</div>
</template>

<script>
import moment from 'moment'
import Detail from '@/components/detail'
import Creload from '@/components/reload'
import Datainfo from '@/components/datainfo'
import Datadetail from '@/components/datadetail'
import Creditaction from '@/components/kreditaction'
import Mirri from '@/components/mirri'
import { orchDataConsumption, mixiNameNotSeven } from '@/services'

export default {
  name: 'kredit',
  components: {
    Detail,
    Creload,
    Datainfo,
    Datadetail,
    Creditaction,
    Mirri
  },
  data () {
    return {
      msg: 'Kredit',
      tplData: {},
      tpl: function(tpath) {
        const inObj = _.get(this.tplData, tpath); var res = null
        if (inObj) {res = inObj
        } else {
          res = tpath.toString()
        } return res
      },
      states: {
        viewAllow: false, showFail: false, mainView: true, isPecka: false, rplnRel: null, detailView: false, creloadView: false, datainfoView: false, datadetailView: false, creditActionView: false, creditAction: { type: 'add', command: "ESTE200", cGroup: '' }, voiceInfinite: false, smsInfinite: false, lastReload: false,
        dataHide: false, onServerError: false, otherRpln: false, showMixi: false
      },
      msisdn: '',
      productdetail: {},
      mixiDataFromBq: [],
      typeExists: { internet: false, voice: false, messages: false },
      baseView: { pgPercentage: 0, voiceValue: 0, smsValue: 0, voicePkg: false, messPkg: false, voicePkgVal: "", messPkgVal: "", voicePkgProl: false, messPkgProl: false, voicePkgProlTxt: "vypnuté", messPkgProlTxt: "vypnuté", voiceInfo: false, dCapsInfo: false, smsPercentage: 0, voicePkgTitle: "Neobmedzené Telekom volania", voicePkgShow: true, voicePkgMixiPrior: false, messPkgMixiPrior: false, dataCountForMixi: 0, mixiProlongList: [] },
      freeCallNrsArr: [], fnfPkg: false, fnfPkgProl: false,
      orchDataConsumption: orchDataConsumption,
      moment: moment
    }
  },
  created: function() {
    var that = this

    if (document.getElementById("msisdnTextSpan") === null) {
      var msisdnTextSpan = document.createElement("span")
      msisdnTextSpan.id = "msisdnTextSpan"
      var msisdnTemp = document.getElementById("jsHolder")
      msisdnTemp.appendChild(msisdnTextSpan)
    }  else {
      var msisdnTextSpan = document.getElementById("msisdnTextSpan")
    }

    var productDetailAllow = false, tplDataAllow = false;

    if (_.isEmpty(this.$store.state.productdetail)) {
      that.$store.dispatch('refreshProductDetail').then(() => {
       if (that.$store.state.httpCodes.productdetail === 200) {
          that.productdetail = that.$store.state.productdetail
          that.msisdn = that.$store.state.productdetail.msisdn
          msisdnTextSpan.innerHTML = '0' + that.msisdn.toString().substring(3)
       }        
       if (that.$store.state.httpCodes.productdetail === 403) {
          window.location.href = '/prihlasenie/?url=' + encodeURIComponent(that.$router.history.base + that.$route.fullPath)
       } else if (that.$store.state.httpCodes.productdetail === 400) {
          window.location.href = '/spotreba'
       } else if (that.$store.state.httpCodes.productdetail === 502) {
          that.states.showFail = true
          that.states.onServerError = true
       } else if (_.isEmpty(that.productdetail)) {
            that.states.showFail = true
       } else {
            productDetailAllow = true
            if (tplDataAllow) {
              that.states.viewAllow = true
              this.setPecka()
            }
          }
      })
    } else {
        that.productdetail = that.$store.state.productdetail
        that.msisdn = that.$store.state.productdetail.msisdn
        msisdnTextSpan.innerHTML = '0' + that.msisdn.toString().substring(3)
        that.states.viewAllow = true
        this.setPecka()
    }
    if (_.isEmpty(this.$store.state.tplData)) {
      that.$store.dispatch('refreshTplData').then(() => {
        that.tplData = that.$store.state.tplData
        tplDataAllow = true
        if (productDetailAllow) {
          that.states.viewAllow = true
          this.setPecka()
        }
      });
    } else {
        that.tplData = that.$store.state.tplData
        that.states.viewAllow = true
        this.setPecka()
    }
  },
  mounted: function() {
  },
  computed: {
    readMsisdn: function() {
      return '0' + String(this.msisdn).substring(3)
    },
    negPercentage: function() { 
      return 100 - this.posPercentage

    },
    posPercentage: function() {
      var checkPerc = this.baseView.pgPercentage
      if (this.baseView.pgPercentage < 0)
        {
          checkPerc = 0
        }
      if (this.baseView.pgPercentage > 100)
        {
          checkPerc = 100
        }
      return checkPerc  
    },
    isMirri: function() {
      return this.productdetail.product?.productNumber === 'PR1920';
    }
  },  
  methods: {
      filterBouquet: function (name) {
        var targetObj = {}, res = {}
        var wallets = this.productdetail.product.subscriberWallets
        if (!Array.isArray(wallets)) {
          wallets = [wallets]
        }
        wallets.forEach(function(v){
          if (v.type === undefined) {
            targetObj = v;
          }
        })
        if (!Array.isArray(targetObj.buckets)) {
          targetObj.buckets = [targetObj.buckets]
        }
        targetObj.buckets.forEach(function(tv){
          if (tv.name == name) {
            res = tv
          }
        })
        return res
      },
      formatMsisdn: function(virgin) {
        return '0' + String(virgin || '').substr(-9)
      },
      setPecka: function() {
        var that = this

        var tmskvoiceBq = {}, tmskvoiceMax = 50000, smsBq = {}, smsMax = 50000
        that.freeCallNrsArr = []
        if (((this.productdetail.product.productName || '').toLowerCase()).indexOf('pecka') !== -1) {
          this.states.isPecka = true
          this.states.rplnRel = "P"
          tmskvoiceBq = this.filterBouquet('PromoX_0')
        } else if (((this.productdetail.product.productName || '').toLowerCase()).indexOf('t karta') !== -1) {
          this.states.isPecka = true
          this.states.rplnRel = "T"
          tmskvoiceBq = this.filterBouquet('T_0')
          smsBq = this.filterBouquet('T_SMS_0')
        } else if (((this.productdetail.product.productName || '').toLowerCase()).indexOf('young') !== -1) {
          this.states.isPecka = "Y";
        }
        if (this.states.isPecka !== "Y") {
          if (!_.isEmpty(tmskvoiceBq)) {
            if (tmskvoiceBq.value < 3) {
              this.states.voiceInfinite = true
            } else {
              if (tmskvoiceBq.value > tmskvoiceMax) { tmskvoiceBq.value = tmskvoiceMax }
              this.baseView.pgPercentage = 100 - ((tmskvoiceBq.value / tmskvoiceMax) * 100)
                if (tmskvoiceBq.value == tmskvoiceMax) {
                  this.baseView.voiceValue = 0
                } else {
                  this.baseView.voiceValue = ((tmskvoiceMax - tmskvoiceBq.value) / 100000).toFixed(2).toString().replace(/\./, ',')
                }
            }
          } else {
              this.baseView.pgPercentage = 0
              this.baseView.voiceValue = 0
              this.states.voiceInfinite = false
          }

          if (!_.isEmpty(smsBq)) {
            if (smsBq.value < 3) {
              this.states.smsInfinite = true
            } else {
              if (smsBq.value > smsMax) { smsBq.value = smsMax }
              var thisPerc = ((smsBq.value / smsMax) * 100)
              if (thisPerc > 100) { thisPerc = 100 }
              this.baseView.smsPercentage = 100 - thisPerc
                if (smsBq.value == smsMax) {
                  this.baseView.smsValue = 0
                } else {
                  this.baseView.smsValue = ((smsMax - smsBq.value) / 100000).toFixed(2).toString().replace(/\./, ',')
                }
            }
          } else {
              this.baseView.smsPercentage = 0
              this.baseView.smsValue = 0
              this.states.smsInfinite = false
          }

          var wallets = this.productdetail.product.subscriberWallets, targetObj = []
          if (!Array.isArray(wallets)) {
            wallets = [wallets]
          }
          wallets.forEach(function(v){
            if (v.type === undefined) {
              targetObj = v;
            }
          })
          if (!Array.isArray(targetObj.buckets)) {
            targetObj.buckets = [targetObj.buckets]
          }
          targetObj.buckets.forEach(function(tv){
            if ((tv.name).toLowerCase().indexOf("freecalls2num") !== -1) {
              if (((tv.endDate) && (moment(tv.endDate) > moment(that.productdetail.timeStamp))) || ((tv.nextChargeDate) && (moment(tv.nextChargeDate) > moment(that.productdetail.timeStamp)))) {
                if ((tv.nextChargeDate) && (moment(tv.nextChargeDate) > moment(that.productdetail.timeStamp))) {
                  tv.fnfPkgProlTxt = "zapnuté"
                  tv.fnfPkgProl = true
                } else {
                  tv.fnfPkgProlTxt = "vypnuté"
                  tv.fnfPkgProl = false
                }
                that.freeCallNrsArr.push(tv)
              }
            }
          })
          if (!_.isEmpty(this.freeCallNrsArr)) {
            this.baseView.fnfPkg = true
          }
        }

        var freeVoiceBq = {};
        var freeVoiceBq1 = this.filterBouquet('Free Voice Onnet')
        var freeVoiceBq2  = this.filterBouquet('Free Voice SK')
        var freeVoiceBq3 = this.filterBouquet('Free Voice Onnet 2')
        if (!_.isEmpty(freeVoiceBq2)) {
          this.baseView.voicePkgTitle = "Neobmedzené hovory";
          freeVoiceBq = freeVoiceBq2;
          this.baseView.voicePkgShow = false        
        }
        if (!_.isEmpty(freeVoiceBq1)) {
          freeVoiceBq = freeVoiceBq1;        
        }
        if (!_.isEmpty(freeVoiceBq3)) {
          freeVoiceBq = freeVoiceBq3;        
          this.baseView.voicePkgShow = false        
        }

        const mixiBq = _.uniq(_.map(this.productdetail.mixMenu, 'pkgType'));
        _.forEach(mixiBq, function(mv,mk){
          var dpIdent = _.filter(that.productdetail.product.subscriberWallets, function(m) { return m.type && m.type.startsWith(mv); });
          if (!_.isEmpty(dpIdent)) {
            try {
              _.forEach(dpIdent, function(iv) {
                if ((iv.buckets.endDate) && ((moment(iv.buckets.endDate)) > (moment(that.productdetail.timeStamp)))) {
                  that.states.showMixi = true;
                }
              })
            } catch(e) { console.log(e.message); }
          }
        });
        var mixiDataFromBq = [];
        var prolongObj = {};
        _.forEach(_.filter(this.productdetail.mixMenu, function(sm) { return sm.deactCommand !== null }), function(so){
          prolongObj[so.bucketName] = _.assign({ bucketName: so.bucketName, commgroup: so.commgroup }, so.deactCommand);
        })
        var mixiProlongList = [];
        var mixiProlEvidenceList = [];
        _.forEach(that.productdetail.product.subscriberWallets, function(mxv, mxk){
          if (mxv.type !== undefined) {
            try {
              if (mxv.type.slice(0,11) === 'MenuPackage' && mxv.buckets.name !== 'MENU' && mxv.buckets.name !== 'MENU_30') {
                mxv.periodObj = mixiNameNotSeven(mxv.buckets.name, mxv.type, prolongObj);
                mxv.readable = (that.tplData.package.detailMixi[mxv.buckets.name] || 'Mixi') + mxv.periodObj.appendTitle;
                if ((mxv.buckets.name.indexOf('ONNET') !== -1) || (mxv.buckets.name.indexOf('FLAT') !== -1)) {
                  mxv.isInfinite = true;
                } else {
                  mxv.isInfinite = false;
                }
                var mTypes = mxv.buckets.name.split('_');
                var pgLeftText = '';
                mxv.unitType = null;
                mxv.pgLeftText = '', mxv.percentagePos = 0, mxv.percentageNeg = 100;
                mxv.prolongable = false;
                switch(mTypes[1]) {
                  case 'DATA': 
                      that.typeExists.internet = true;
                      mxv.unitType = mTypes[1].toLowerCase();
                      mxv.pgLeftText = 'Prenesené z voľných';
                      pgLeftText = 'Internet';
                    break;  
                  case 'VOICE': 
                      that.typeExists.voice = true;
                      mxv.unitType = mTypes[1].toLowerCase();
                      mxv.pgLeftText = 'Vyčerpané z voľných';
                      pgLeftText = 'Volania';
                      // hide old pkg
                      that.baseView.voicePkgMixiPrior = true;
                      //
                    break;  
                  case 'SMS': 
                      that.typeExists.messages = true;
                      mxv.unitType = mTypes[1].toLowerCase();
                      mxv.pgLeftText = 'Vyčerpané z voľných';
                      pgLeftText = 'SMS';
                      // hide old pkg
                      that.baseView.messPkgMixiPrior = true;
                      //
                    break;  
                }

                var evidenceCut = ["MenuPackageProlong", "MenuPackage30Prolong"];
                if (evidenceCut.indexOf(mxv.type) === -1) {
                   if (mxv.buckets.nextChargeDate !== undefined) {
                     if (moment(that.productdetail.timeStamp) < moment(mxv.buckets.nextChargeDate)) {
                  //     mixiProlongList.push(mxv);
                       mxv.prolongable = true;
                     }
                   }
                  if (mxv.isInfinite) {
                    mxv.pgLeftText = pgLeftText;
                  }

                  switch (mxv.unitType) {
                    case 'data':
                      if (mxv.isInfinite) {
                        mxv.pgVal = 'neobmedzene'; 
                      } else {
                        mxv.pgVal = that.orchDataConsumption(mxv.bucketSize, mxv.buckets.value);
                      }
                      if (parseInt(mxv.buckets.value) < 1500) { that.typeExists.internet = false; }
                      break;
                    case 'voice':
                      if (mxv.isInfinite) {
                        mxv.pgVal = 'neobmedzene'; 
                      } else {
                        var maxSize = Math.round(parseInt(mxv.bucketSize) / 60);
                        mxv.pgVal = Math.abs(maxSize - (Math.round(parseInt(mxv.buckets.value) / 60))) + ' / ' + maxSize + ' minút';
                      }
                      if ((parseInt(mxv.buckets.value < 60)) || (mxv.buckets.name.includes('ONNET'))) { that.typeExists.voice = false; }
                      break;
                    case 'sms':
                      if (mxv.isInfinite) {
                        mxv.pgVal = 'neobmedzene'; 
                      } else {
                        mxv.pgVal = Math.abs(parseInt(mxv.bucketSize) - parseInt(mxv.buckets.value)) + ' / ' + mxv.bucketSize + ' SMS';
                      }
                      if ((parseInt(mxv.buckets.value) < 2) || (mxv.buckets.name.includes('ONNET'))) { that.typeExists.messages = false; }
                      break;
                  }
                  mxv.percentagePos = Math.round(100 * (parseInt(mxv.buckets.value || '1') / parseInt(mxv.bucketSize || '1')));
                  if (mxv.percentagePos > 100) { mxv.percentagePos = 100; }
                  if (mxv.percentagePos < 0) { mxv.percentagePos = 0; }
                  mxv.percentageNeg = 100 - mxv.percentagePos;

                  if ((mxv.buckets.endDate) && ((moment(mxv.buckets.endDate)) > (moment(that.productdetail.timeStamp)))) {
                    mxv.endDate = moment(mxv.buckets.endDate).format('D.M.YYYY H:mm');
                    mixiDataFromBq.push(mxv);
                  }
                } else {
                  mixiProlEvidenceList.push(mxv)
                }
              }
            } catch(e) { that.states.showMixi = false; }
          }
        })

        // mixiProlongList = _.uniqBy(mixiProlongList, function(sq) { return sq.periodObj.days })

        // _.forEach(mixiProlongList, function(cons){
        //   const singleEvidence = _.filter(mixiProlEvidenceList, function(ef) { return ef.periodObj.days === cons.periodObj.days })
        //   if (singleEvidence[0]) {
        //     const singleProlObj = prolongObj[singleEvidence[0].buckets.name];
        //     if (singleProlObj) {
        //       that.baseView.mixiProlongList.push({ action: true, commandName: singleProlObj.commgroup, commandType: singleProlObj.value, nextChargeDate: moment(cons.buckets.nextChargeDate).format('D.M.YYYY'), periodObj: cons.periodObj });
        //     }
        //   }
        // })

        this.mixiDataFromBq = _.clone(mixiDataFromBq);

        var benefitVoice = this.filterBouquet('FreeCalls4Teacher')
        if (!_.isEmpty(benefitVoice)) {
          freeVoiceBq = benefitVoice
          this.baseView.voicePkgTitle = "Neobmedzené hovory bezplatne"
          this.baseView.voicePkgShow = false
        }

        var freeSmsBq = this.filterBouquet('Free SMS SK')
        if (!_.isEmpty(freeVoiceBq)) {
          if (((freeVoiceBq.endDate) && (moment(freeVoiceBq.endDate) > moment(this.productdetail.timeStamp))) || ((freeVoiceBq.nextChargeDate) && (moment(freeVoiceBq.nextChargeDate) > moment(this.productdetail.timeStamp)))) {
            this.baseView.voicePkg = !this.baseView.voicePkgMixiPrior;
            this.baseView.voicePkgProlTxt = 'vypnuté'
            this.baseView.voicePkgProl = false
            this.baseView.voicePkgVal = moment(freeVoiceBq.endDate).format('D.M.YYYY H:mm')
              if (freeVoiceBq.nextChargeDate !== undefined) {
                if (moment(this.productdetail.timeStamp) < moment(freeSmsBq.nextChargeDate)) {
                  this.baseView.voicePkgProlTxt = 'zapnuté'
                  this.baseView.voicePkgProl = true
                }
              }
          }
        }
        if (!_.isEmpty(freeSmsBq)) {
          if (((freeSmsBq.endDate) && (moment(freeSmsBq.endDate) > moment(this.productdetail.timeStamp))) || ((freeSmsBq.nextChargeDate) && (moment(freeSmsBq.nextChargeDate) > moment(this.productdetail.timeStamp)))) {
            this.baseView.messPkg = !this.baseView.messPkgMixiPrior;
            this.baseView.messPkgProlTxt = 'vypnuté'
            this.baseView.messPkgProl = false
            this.baseView.messPkgVal = moment(freeSmsBq.endDate).format('D.M.YYYY H:mm')
              if (freeSmsBq.nextChargeDate !== undefined) {
                if (moment(this.productdetail.timeStamp) < moment(freeSmsBq.nextChargeDate)) {
                  this.baseView.messPkgProlTxt = 'zapnuté'
                  this.baseView.messPkgProl = true
                }
            }
          }
        }
        if (this.$route.query.dobi !== undefined) {
          this.states.mainView = !this.states.mainView; 
          this.states.creloadView = !this.states.creloadView
        }
      },      
      dataCount: function(res) {
        this.baseView.dataCountForMixi = res;
      },
      doRedirect: function(targetURL) {
        window.location = targetURL;
      }
    }
  }
</script>

<style scoped>
.xspace {
  margin-top: 0.4rem;
}
</style>
